<template>
  <div id="app">
    <Header></Header>
    <router-view />
    <Footer v-if="$store.state.routerName != '/f_home' && $store.state.routerName != '/ipList'"></Footer>
    <GoTop v-if="$store.state.routerName != '/f_home' && $store.state.routerName != '/ipList'"></GoTop>
  </div>
</template>

<script>
import axios from "axios";
export default {
  name: "App",
  data() {
    return {
      form: {
        ipAddr: ''
      }
    };
  },
  mounted() {
    // 高德自动获取浏览器ip，获取国家，省份，城市
    fetch('http://ip-api.com/json/')
      .then(response => response.json())
      .then(data => {
        this.form.ipAddr = data.query
        const country = data.country;
        this.form.country = country;
        console.log(this.form.ipAddr)
        console.log(`国家: ${country}`);
        axios({
          method: "get",
          url: "http://www.kintop-tech.com/api/net/address",
          params: this.form
        }).then(res => {
          console.log(res.data);
        })
      });
  },
  methods: {}
};
</script>

<style lang="scss">
* {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}

#app {
  padding-top: 94px;
}

ul {
  margin: 0;
  padding: 0;
}

.headline {
  text-align: center;
  padding-bottom: 30px;

  color: #fff;

  h1 {
    display: inline-block;
    font-size: 28px;
    font-weight: 600;
    line-height: 36px;
    position: relative;
    text-transform: uppercase;
  }

  h1::before,
  h1::after {
    border-bottom: 1px double #fff;
    border-top: 1px double #fff;
    content: "";
    display: inline-block;
    height: 4px;
    margin: 0 20px;
    vertical-align: middle;
    width: 30px;
  }
}

/*滚动条统一样式*/

body::-webkit-scrollbar {
  width: 6px;
  height: 10px;
}

body::-webkit-scrollbar-track {
  // background: #fff;
  background: #f1f1f1;
  border-radius: 2px;
}

body::-webkit-scrollbar-thumb {
  background: #bbb;
  border-radius: 10px;
}

body::-webkit-scrollbar-thumb:hover {
  background: #aaa;
}

body::-webkit-scrollbar-corner {
  background: #179a16;
}

.scroll {
  overflow: auto;
}

.scroll::-webkit-scrollbar {
  width: 6px;
  height: 10px;
}

.scroll::-webkit-scrollbar-track {
  // background: #fff;
  background: #f1f1f1;
  border-radius: 2px;
}

.scroll::-webkit-scrollbar-thumb {
  background: #aaa;
  border-radius: 10px;
}

.scroll::-webkit-scrollbar-thumb:hover {
  background: #888;
}

.scroll::-webkit-scrollbar-corner {
  background: #179a16;
}
</style>



// WEBPACK FOOTER //
// src/App.vue